'use strict';

var util = require('./util');
var axios = require('axios');
require('core-js/fn/promise');

var currentQuery = null,
    lastQuery = null,
    runningQuery = null,
    listTotal = -1,
    listCurrent = -1,
    delay = 30,
    resultsContainer,
    endingOffset,
    endingText,
    tsY;

/**
 * @function
 * @description Handles keyboard's arrow keys
 * @param keyCode Code of an arrow key to be handled
 */
function handleArrowKeys(keyCode) {
    switch (keyCode) {
    case 38:
        // keyUp
        listCurrent = (listCurrent <= 0) ? (listTotal - 1) : (listCurrent - 1);
        break;
    case 40:
        // keyDown
        listCurrent = (listCurrent >= listTotal - 1) ? 0 : listCurrent + 1;
        break;
    default:
        // reset
        listCurrent = -1;
        return false;
    }

    var resultsContainerChild = resultsContainer.childNodes();

    for (var i = 0; i < resultsContainerChild.length; i++) {
        resultsContainerChild[i].classList.remove('selected');

        if (i == listCurrent) {
            resultsContainerChild[i].classList.add('selected');
        }

        var selectedSuggestion = resultsContainer.querySelectorAll('.selected .suggestionterm');
        document.querySelector('input[name="q"]').value = selectedSuggestion[0].textContent;
    }

    return true;
}

var searchsuggest = {
    /**
     * @function
     * @description Configures parameters and required object instances
     */
    init: function (container, defaultValue) {
        var $searchContainer = container;
        var $searchForm = $searchContainer.querySelector('form[name="simpleSearch"]');
        var $searchField = $searchForm.querySelector('input[name="q"]');
        var $searchOverlay = document.querySelector('.search-overlay');
        endingOffset = document.querySelector('.search-suggestion-ending__offset');
        endingText = document.querySelector('.search-suggestion-ending__text');

        // disable browser auto complete
        $searchField.setAttribute('autocomplete', 'off');

        // on focus listener (clear default value)
        $searchField.addEventListener('focus', function () {
            if (!resultsContainer) {
                // create results container if needed
                resultsContainer = document.createElement('div');
                resultsContainer.classList.remove('active');
                resultsContainer.setAttribute('class', 'search-suggestions-container');
                $searchContainer.appendChild(resultsContainer);
            }

            $searchOverlay.classList.remove('ms-hide');

            if ($searchField.value === defaultValue) {
                $searchField.value = '';
                endingText.innerHTML = '';
            }
        });

        // on key up listener
        $searchField.addEventListener('keyup', function(e) {
            // get keyCode (window.event is for IE)
            var keyCode = e.keyCode || window.event.keyCode;

            // check and treat up and down arrows
            if (handleArrowKeys(keyCode)) {
                return;
            }

            var suggestionText = endingOffset.textContent + endingText.textContent;
            var searchFieldValue = $searchField.value.trim();
            // fill input value with suggestion on pressing ENTER key or submit the form
            if (keyCode === 13 && searchFieldValue) {
                e.preventDefault();
                // if input has only 3 letters then we don't replace input value with suggestion
                // because customer would not expect this to happen
                if (suggestionText.length > 3 && $searchField.value.toLowerCase() !== suggestionText.toLowerCase()) {
                    if (suggestionText.length > $searchField.value.length) {
                        $searchField.value = suggestionText;
                        endingOffset.textContent = '';
                        endingText.textContent = '';
                    }
                } else {
                    $searchForm.submit();
                }
                return;
            }

            currentQuery = $searchField.value;
            currentQuery = currentQuery.trim();

            // no query currently running, init an update
            if (!runningQuery) {
                runningQuery = currentQuery;
                setTimeout(this.suggest.bind(this), delay);
            }
        }.bind(this));

        $searchField.addEventListener('keydown', function(e) {
            // get keyCode (window.event is for IE)
            var keyCode = e.keyCode || window.event.keyCode;

            if (keyCode === 13) {
                e.preventDefault();
            }
        });

        $searchForm.addEventListener('submit', (e) => {
            if (!$searchField.value.trim()) {
                e.preventDefault();
            }
        });

        endingText.addEventListener('click', () => {
            $searchField.value = endingOffset.textContent + endingText.textContent;
            endingOffset.textContent = '';
            endingText.textContent = '';
        });
    },

    /**
     * @function
     * @description trigger suggest action
     */
    suggest: function() {
        // check whether query to execute (runningQuery) is still up to date and had not changed in the meanwhile
        // (we had a little delay)
        if (runningQuery !== currentQuery) {
            // update running query to the most recent search phrase
            runningQuery = currentQuery;
        }

        // if it's empty clear the results box and return
        if (runningQuery.length === 0) {
            this.clearResults();
            runningQuery = null;
            return;
        }

        // removed the special characters from search keyword
        runningQuery = runningQuery.replace(/["'<>]/g, '');

        // if the current search phrase is the same as for the last suggestion call, just return
        if (lastQuery === runningQuery) {
            runningQuery = null;
            return;
        }

        // build the request url
        var reqUrl = util.appendParamToURL(Urls.searchsuggest, 'q', runningQuery);

        var touchStart = function(e) {
            tsY = e.originalEvent.touches[0].clientY;
        };

        var touchMove = function(e) {
            var tmY = e.originalEvent.touches[0].clientY;
            var isUpOverScroll = e.target.scrollTop === 0 && tsY < tmY;
            // 1px is lost, probably due to borders/box-sizing etc
            var isDownOverScroll = (e.target.scrollTop >= e.target.scrollHeight - e.target.offsetHeight - 1) && tsY > tmY;

            if (isUpOverScroll || isDownOverScroll) {
                e.preventDefault();
            }
        };

        // execute server call
        axios.get(reqUrl).then(function(data) {
            var suggestionHTML = data.data,
                ansLength = suggestionHTML.trim().length;

            // if there are results populate the results div
            if (ansLength === 0) {
                var htmlBody = document.querySelectorAll('html, body');

                htmlBody[0].classList.remove('search-disable-scroll');
                htmlBody[1].classList.remove('search-disable-scroll');

                if (htmlBody[1].querySelector('.searchOverlayOpened') != null) {
                    htmlBody[1].querySelector('.searchOverlayOpened').removeEventListener('touchstart.searchOverlayOpened', touchStart);
                    htmlBody[1].querySelector('.searchOverlayOpened').removeEventListener('touchmove.searchOverlayOpened', touchMove);
                }

                this.clearResults();
            } else {
                // update the results div
                resultsContainer.innerHTML = suggestionHTML;
                var suggestedstring = document.getElementById('suggestedstring');

                if (suggestedstring) {
                    endingText.textContent = suggestedstring.textContent;
                    endingOffset.textContent = runningQuery;
                } else {
                    endingText.textContent = '';
                }

                var lastProductValue = resultsContainer.querySelector('input.productcount-value:last-child');
                var lastEditorialValue = resultsContainer.querySelector('input.editorialcontentcount-value:last-child');

                if (lastProductValue != null) {
                    resultsContainer.querySelector('span.productcount').textContent = ' (' + resultsContainer.querySelector('input.productcount-value:last-child').value + ')';
                }

                if (lastEditorialValue != null) {
                    resultsContainer.querySelector('span.editorialcontentcount').textContent = ' (' + resultsContainer.querySelector('input.editorialcontentcount-value:last-child').value + ')';
                }

                resultsContainer.classList.add('active');
            }

            // record the query that has been executed
            lastQuery = runningQuery;
            // reset currently running query
            runningQuery = null;

            // check for another required update (if current search phrase is different from just executed call)
            if (currentQuery !== lastQuery) {
                // ... and execute immediately if search has changed while this server call was in transit
                runningQuery = currentQuery;
                setTimeout(this.suggest.bind(this), delay);
            }
            this.hideLeftPanel();
        }.bind(this));
    },
    /**
     * @function
     * @description
     */
    clearResults: function() {
        if (!resultsContainer) {
            return;
        }

        resultsContainer.classList.remove('active');
        resultsContainer.innerHTML = '';
    },
    /**
     * @function
     * @description
     */
    hideLeftPanel: function () {
        var searchPhraseSuggestion = document.querySelector('.search-phrase-suggestion a');
        var searchPhraseSuggestionText = searchPhraseSuggestion != null ? searchPhraseSuggestion.textContent : '';
        var searchSuggestionLeftPanel = document.querySelector('.search-suggestion-left-panel-hit a');
        var searchSuggestionLeftPanelText = searchSuggestionLeftPanel != null ? searchSuggestionLeftPanel.textContent : '';

        // hide left panel if there is only a matching suggested custom phrase
        if (document.querySelector('.search-suggestion-left-panel-hit') != null && document.querySelector('.search-suggestion-left-panel-hit').length === 1 && searchPhraseSuggestionText.replace(/(^[\s]+|[\s]+$)/g, '').toUpperCase() === searchSuggestionLeftPanelText.toUpperCase()) {
            document.querySelector('.search-suggestion-left-panel').style.display = 'none';
            document.querySelector('.search-suggestion-wrapper-full').classList.add('search-suggestion-wrapper');
            document.querySelector('.search-suggestion-wrapper').classList.remove('search-suggestion-wrapper-full');
        }
    }
};

module.exports = searchsuggest;
